import React from 'react';
import { Switch, Route } from 'react-router';
import MediaList from './MediaList';
import RouteGetter from '../../../routes/RouteGetter';

const Media = () => {
  return (
    <Switch>
      <Route path={RouteGetter.get('project').mediaPath()}>
        <MediaList />
      </Route>
    </Switch>
  );
};

export default Media;
